module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex content-sale flex-70 space-between align-center"
  }, [_c('div', {
    staticClass: "d-flex align-center wrap section-sale"
  }, [_c('button', {
    staticClass: "btn-sale",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goTo('home')
      }
    }
  }, [_vm._v("Continuar haciendo compras")]), _vm._v(" "), _c('div', {
    staticClass: "text-sale"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Carrito de compras")]), _vm._v(" "), _c('span', {
    staticClass: "text-gray ml-1"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "text-gray ml-1"
  }, [_vm._v(_vm._s(_vm.productQuantity))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn-empty",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.carEmpty
    }
  }, [_vm._v("Vaciar el carrito")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-767bbdd5","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/componentSale.vue
// module id = 1138
// module chunks = 49